import '@availity/yup';
import * as yup from 'yup';

const formValidation = () =>
  yup.object().shape({
    name: yup.string().required('Il nome è obbligatorio'),
    code: yup
      .string()
      .min(3, 'Il codice deve essere di almeno 3 caratteri')
      .required('Il codice è obbligatorio'),
    monthlyCommission: yup
      .number()
      .typeError('La commissione mensile deve essere un numero')
      .positive('La commissione mensile deve essere maggiore di 0')
      .required('La commissione mensile è obbligatoria'),
    semiannualCommission: yup
      .number()
      .typeError('La commissione semestrale deve essere un numero')
      .positive('La commissione semestrale deve essere maggiore di 0')
      .required('La commissione semestrale è obbligatoria'),
    isActive: yup.boolean().required(),
  });

export default formValidation;
